export default function () {
  return {
    loading: false,
    zammitUpdates: [],
  };
}
